import { gql } from '@efficiently/client-core-graphql-models';

export const RESOLVE_CLIENT_PORTAL_ORG = gql(`
	query ResolveClientPortalOrg($hostname: String!) {
		resolveClientPortalOrg(hostname: $hostname) {
			orgId
		}
	}
`);
